import { useMemo } from 'react';

import { useAllLegalEntities } from '~/data/legalEntity/useAllLegalEntities';

export const useLegalEntity = (legalEntityId?: number) => {
  const { legalEntities, ...dataStates } = useAllLegalEntities();

  const legalEntity = useMemo(
    () =>
      legalEntityId
        ? legalEntities.find((le) => le.fLegalEntityId === legalEntityId)
        : undefined,
    [legalEntities, legalEntityId],
  );

  return {
    legalEntity,
    ...dataStates,
  };
};
